<template>
  <form novalidate @submit.prevent="disputeMow">
    <LsModal title="Service Incorrectly Marked as Complete" track-id="dispute_mow_modal">
      <template #body>
        <BLoading :active.sync="isLoading" :is-full-page="false" />
        <div v-if="!isLoading">
          <p v-if="noDisputableScheduleEvents" class="dispute-mow-modal--no-disputable-events">
            Looks like you haven’t had any services completed recently. If you need help, please

            <LsClickable
              class="dispute-mow-modal--message-LS"
              track-id="dispute_mow_modal-message_LS"
              @click="messageLS"
              >click here to contact {{ brandName }}.</LsClickable
            >
          </p>
          <div v-else>
            <p class="dispute-mow-modal--please-select">
              <strong>Please select the service that was not completed:</strong>
            </p>
            <LsRadios
              v-for="item in propertiesWithDisputableScheduleEvents"
              :key="item.label"
              v-model="currentDispute"
              :validation="{ required: true }"
              :label="item.label"
              track-id="dispute_mow_modal-choose_dispute"
              name="choose_dispute"
              :options="item.options"
              class="dispute-mow-modal--radios"
            />
          </div>
        </div>
      </template>
      <template #footer>
        <LsButton
          v-if="!noDisputableScheduleEvents"
          text="ok"
          track-id="dispute_mow_modal-ok"
          type="submit"
          :loading="isLoading"
        />
      </template>
    </LsModal>
  </form>
</template>

<script>
import VueTypes from 'vue-types';
import { LsModal, LsButton, LsRadios, LsClickable } from '@/components/common';
import { mapActions, mapState, mapGetters } from 'vuex';
import _ from 'lodash';
import {
  DISPUTE__GET_DISPUTABLE_SCHEDULE_EVENTS,
  DISPUTE__INITIALIZE_CURRENT_DISPUTE,
  DISPUTE__PROPERTIES_WITH_DISPUTABLE_SCHEDULE_EVENTS,
  PROPERTIES__GET_PROPERTIES_AND_SCHEDULES,
} from '@/store/types';
import { lsFilters, lsScheduleHelpers } from 'ls-vue-common';
import { themedComponentMixin } from '@/mixins';

export default {
  name: 'DisputeMowModal',
  $_veeValidate: {
    validator: 'new',
  },
  components: {
    LsModal,
    LsButton,
    LsRadios,
    LsClickable,
  },
  mixins: [themedComponentMixin],
  props: {
    targetProperty: VueTypes.number.def(0),
  },
  data() {
    return {
      currentDispute: null,
    };
  },
  computed: {
    ...mapState(['dispute', 'properties']),
    ...mapGetters([DISPUTE__PROPERTIES_WITH_DISPUTABLE_SCHEDULE_EVENTS]),
    isLoading() {
      return this.dispute.loadingStatus.isLoading || this.properties.loadingStatus.isLoading;
    },
    propertiesWithDisputableScheduleEvents() {
      if (!this[DISPUTE__PROPERTIES_WITH_DISPUTABLE_SCHEDULE_EVENTS]) {
        return [];
      }

      return this[DISPUTE__PROPERTIES_WITH_DISPUTABLE_SCHEDULE_EVENTS].filter(
        ({ property: { id }, data }) => {
          return this.targetProperty ? id === this.targetProperty && data.length : true;
        }
      ).map((propertyById) => {
        return {
          label: propertyById.property.street,
          options: _.map(propertyById.data, (event) => {
            return {
              label: `${lsScheduleHelpers.getScheduleServiceName({
                schedule: event.schedule,
              })} (${lsFilters.date({
                date: event.status_set_at,
              })})`,
              key: `${event.scheduleevent_id}`,
              value: {
                schedule_event: event,
                dispute_type: 'no_work_done',
                property_id: event.property.property_id,
                schedule_id: event.schedule.schedule_id,
                scheduleevent_id: event.scheduleevent_id,
              },
            };
          }),
        };
      });
    },
    noDisputableScheduleEvents() {
      return _.isEmpty(this.dispute.disputableScheduleEvents);
    },
  },
  created() {
    this[PROPERTIES__GET_PROPERTIES_AND_SCHEDULES]();
    this[DISPUTE__GET_DISPUTABLE_SCHEDULE_EVENTS]();
  },
  methods: {
    ...mapActions([
      DISPUTE__GET_DISPUTABLE_SCHEDULE_EVENTS,
      DISPUTE__INITIALIZE_CURRENT_DISPUTE,
      PROPERTIES__GET_PROPERTIES_AND_SCHEDULES,
    ]),
    async disputeMow() {
      const valid = await this.$validator.validateAll();
      if (!valid) {
        return;
      }
      this[DISPUTE__INITIALIZE_CURRENT_DISPUTE]({
        schedule_event: this.currentDispute.schedule_event,
        dispute_type: this.currentDispute.dispute_type,
        property_id: this.currentDispute.property_id,
        schedule_id: this.currentDispute.schedule_id,
        scheduleevent_id: this.currentDispute.scheduleevent_id,
      });
      this.$parent.close();
    },
    messageLS() {
      this.$parent.close();
      this.$router.push({
        name: 'messageLS',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.dispute-mow-modal--please-select {
  margin-bottom: 15px;
}
.dispute-mow-modal--radios {
  margin-bottom: 15px;
}
.dispute-mow-modal--message-LS {
  color: $blue;
}
.dispute-mow-modal--no-disputable-events {
  padding: 15px 20px;
  background-color: $primary-light;
}
.themed-app {
  .dispute-mow-modal--no-disputable-events {
    background-color: $theme-color-primary-light;
  }
  .dispute-mow-modal--message-LS {
    color: $theme-color-blue;
  }
}
</style>
